// ============================================================================
// page-author / header.js
// ----------------------------------------------------------------------------
// The author template doesn't have a hero image to sit behind the header, so
// the global "overlay" header (absolute, transparent) would float over the
// first section weirdly. Strip the `oxy-overlay-header` class so the header
// lays out in normal document flow on this template only.
//
// `#_header-10-1133` is the global Oxygen header builder element. If you
// later regenerate or replace it, update this selector to match.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("#_header-10-1133");
  if (!header) return;
  header.classList.remove("oxy-overlay-header");
});
